var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetentLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "210mm",
    height: "77.7mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 21376.55 7909.32",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil0 {fill: #fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "netent-logo.svg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M18312.58 1674.5l3063.97 0 0 890.69 -1068.83 0 0 3776.52 -926.32 0 0 -3776.52 -1068.83 0 0 -890.69zm-3954.66 0l819.43 0 1817.01 2850.21 0 -2850.21 926.32 0 0 4667.21 -819.43 0 -1817.01 -2850.21 0 2850.21 -926.32 0 0 -4667.21zm-2921.46 0l2422.68 0 0 890.69 -2137.66 0 0 997.57 1817.01 0 0 890.69 -1817.01 0 0 997.57 2137.66 0 0 890.69 -2422.68 0 0 1567.61 -178.14 0 0 -7909.32 178.14 0 0 1674.5zm-7374.91 0l3063.97 0 0 890.69 -2102.03 0 0 997.57 1817.01 0 0 890.69 -1817.01 0 0 997.57 2102.03 0 0 890.69 -3063.97 0 0 -4667.21zm-4061.55 0l855.06 0 1781.38 2850.21 0 -2850.21 926.32 0 0 4667.21 -819.43 0 -1817.01 -2850.21 0 2850.21 -926.32 0 0 -4667.21zm7553.05 0l3063.97 0 0 890.69 -1068.83 0 0 3776.52 -926.32 0 0 -3776.52 -1068.83 0 0 -890.69z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetentLogo);
export default __webpack_public_path__ + "static/media/netent-logo.228ac1d72944f93a314f03cd6e149403.svg";
export { ForwardRef as ReactComponent };